// extracted by mini-css-extract-plugin
module.exports = {"request-changes-popup":"RequestChangesPopup_request-changes-popup__3GVS8","text-area":"RequestChangesPopup_text-area__LEUs2"};